import { Helmet } from 'react-helmet-async';

import {
  PATH_MISSION_DEFAULT,
  PATH_MISSION_REPORTS,
  PATH_MISSION_REPORTS_INIT,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { Loading } from '../../components/Loading';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { MissionContextStatus } from '../../contexts/MissionContext/types/mission-context.type';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { MissionReportInit } from './Init';

export const MissionReportInitPage = () => {
  const missionContext = useMissionContext();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();

  const { folderId, missionId } = missionContext;

  const { paths: missionPaths } = useBuildPaths(
    {
      default: PATH_MISSION_DEFAULT,
      reports: PATH_MISSION_REPORTS,
      initReport: PATH_MISSION_REPORTS_INIT,
    },
    { folderId, missionId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            "Initialisation d'un Rapport",
            missionContext.mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          ...missionBreadcrumbPaths,
          { to: missionPaths.reports, label: 'rapports', key: 'reports' },
          { to: missionPaths.initReport, label: 'nouveau', key: 'initReport' },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle
      code={missionContext.mission?.code}
      title="Initialisation d'un Rapport"
    />
  );

  if (missionContext.status !== MissionContextStatus.Ready) {
    return (
      <>
        <Loading />
        {beforeTitleContent}
        {titleContent}
      </>
    );
  }

  return (
    <>
      {beforeTitleContent}
      {titleContent}
      <MissionReportInit />
    </>
  );
};
